import ApiHelper from '../../utils/apiHelper';

export const GET_SITE_SETTINGS_REQUEST = 'settings/GET_SITE_SETTINGS_REQUEST';
export const GET_SITE_SETTINGS_SUCCESS = 'settings/GET_SITE_SETTINGS_SUCCESS';
export const GET_SITE_SETTINGS_FAILURE = 'settings/GET_SITE_SETTINGS_FAILURE';
export const UPDATE_TOPBAR_COLOR = 'settings/UPDATE_TOPBAR_COLOR';
export const UPDATE_SIDEBAR_COLOR = 'settings/UPDATE_SIDEBAR_COLOR';

export const getSiteSettings = () => (dispatch) => {
  dispatch({ type: GET_SITE_SETTINGS_REQUEST });
  return ApiHelper.get('/api/management/site-settings/')
    .then((res) => {
      dispatch({
        type: GET_SITE_SETTINGS_SUCCESS,
        payload: res.data,
      });
    })
    .catch((err) => {
      console.log(err);
      dispatch({
        type: GET_SITE_SETTINGS_FAILURE,
      });
    });
};

export const updateSiteSettings = (payload) => {
  return {
    type: GET_SITE_SETTINGS_SUCCESS,
    payload,
  };
};

export const updateTopBarColor = (color) => {
  return {
    type: UPDATE_TOPBAR_COLOR,
    payload: color,
  };
};

export const updateSideBarColor = (color) => {
  return {
    type: UPDATE_SIDEBAR_COLOR,
    payload: color,
  };
};
